export default __webpack_public_path__ + "static/media/Raider's Boots of the Grasping Wild.01fb6653.jpg";